<div class="content">
  <div class="title">关于 YouTube 服务的补偿说明</div>
  <div mat-dialog-content>
    <div class="txt1">亲爱的用户：</div>
    <div class="txt2">
      很抱歉，您的 YouTube 订阅因官方政策更改而失效了。
      我们已尝试向原渠道申诉钱款，但因国际银行结算规则限
      制，原订单无法追回资金，对此我们深感愧疚。
    </div>

    <div class="txt3">关于平台充值与退款政策说明</div>
    <div class="txt1 space2">
      根据平台<span
        (click)="goto('/agreement')"
        style="cursor: pointer; text-decoration-line: underline"
        >充值服务退款政策</span
      >，充值订单原则上不支持退款，“充值成功“仅表示充值操作已完成，平台不对后续账户状态、会员权益或使用结果作出担保。
    </div>
    <div class="txt3">关于平台补贴方案说明</div>
    <div class="txt1 space2">
      为了最大程度挽回您的损失，我们在不赚取任何利润的前 提下，为您申请到了
      成本价转迁方案：
    </div>

    <div class="txt5">
      <div class="left">
        <div class="left1">平台补贴价</div>
        <div class="left2">290.00/年</div>
      </div>
      <div class="right">
        <div class="right1">原价</div>
        <div class="right2">368.88/年</div>
      </div>
    </div>
  </div>
  <button matRipple (click)="goto('/user/profile/seats')">前往更换</button>
</div>
